<template>
    <b-form-input id="longitude" type="text" :disabled="disabled" v-model="floatValue" :formatter="formatFloat"></b-form-input>
</template>

<script>
export default {
    name: "floatInput",
    props: {
        value: Number,
        disabled: Boolean
    },
    computed: {
        floatValue: {
            get: function() {return this.value},
            set: function(newValue) {
                this.$emit('input' , parseFloat(newValue) )
            }
        }
    },
    methods: {
        formatFloat( newValue ) {
            
            if( isNaN( parseFloat(""+newValue) ) )
                return this.value;
            else {
                if( newValue.charAt(newValue.length-1) == '.' && 
                    newValue.indexOf('.') == newValue.lastIndexOf('.') )
                    return newValue;
                else {
                    return parseFloat(newValue).toString();
                }
            }
        }
    }
}
</script>